<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Cleaner Events</h4>
    <hr>
    <b-row class="mb-3">
      <b-col md="3">
        <b-form-group label="Cleaner">
          <b-select
            v-model="selectedCleaner"
            :options="cleaners">
            <option
              :value="null"
              disabled>
              -- Select a cleaner --
            </option>
          </b-select>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Event Period">
          <date-picker
            v-model="dateRange"
            :shortcuts="false"
            width="100%"
            placeholder="Start Date - End Date"
            lang="en"
            range />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Event Name">
          <b-select
            v-model="eventName"
            :options="eventNames">
            <option value="all">
              -- All event --
            </option>
          </b-select>
        </b-form-group>
      </b-col>
      <b-col
        md="2"
        align-self="center"
        class="pt-2">
        <b-btn
          :disabled="!selectedCleaner"
          variant="primary"
          @click="searchEvents">
          Search
        </b-btn>
      </b-col>
    </b-row>
    <div class="mb-3 text-right">
      <b-btn
        v-show="items.length"
        :disabled="isFetching || !items.length"
        variant="success"
        type="button"
        size="sm"
        @click="exportReport">
        <i class="fa fa-file-excel-o"/>
        Download
      </b-btn>
    </div>
    <!-- Data Table -->
    <div class="row">
      <div class="col">
        <div
          v-if="isFetching"
          style="margin: 0 auto; width: 10px;">
          <div class="loader-dark-blue medium mb-5 mt-5"/>
        </div>
        <b-alert
          :show="isEmpty"
          variant="danger"
          class="text-center">
          Data is empty
        </b-alert>
        <div v-if="!isFetching && items.length">
          <b-table
            :fields="fields"
            :items="items"
            :per-page="itemsPerPage"
            :current-page="currentPage"
            fixed
            hover
            striped>
            <template
              v-slot:cell(createdAt)="data">
              {{ data.value | date }}
            </template>
          </b-table>
          <b-pagination
            v-show="items.length > 10"
            :total-rows="items.length"
            :per-page="itemsPerPage"
            v-model="currentPage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import { mapState } from 'vuex'
import { helperService, toastr } from '@/services/'
import FileSaver from 'file-saver'

export default {
  components: {
    DatePicker
  },
  data () {
    return {
      itemsPerPage: 15,
      currentPage: 1,
      itemsCount: 0,
      isFetching: false,
      cleaner: '',
      isEmpty: false,
      selectedCleaner: null,
      dateRange: '',
      eventName: 'all',
      eventNames: [
        {text: 'Page Access', value: 'PAGE_ACCESS'},
        {text: 'Submit station selection', value: 'SUBMIT_STATION_SELECTION'},
        {text: 'Submit unlock vehicle', value: 'SUBMIT_UNLOCK_VEHICLE'},
        {text: 'Submit cleaning log', value: 'SUBMIT_CLEANING_LOG'},
        {text: 'Send Command', value: 'SEND_COMMAND'}
      ],
      fields: [
        'userName',
        'page',
        'eventName',
        'eventDetail',
        'createdAt'
      ]
    }
  },
  computed: {
    ...mapState('cleanerEvents', {
      items: state => state.events,
      cleaners: state => state.cleaners
    })
  },
  created () {
    this.$store.cache.dispatch('cleanerEvents/fetchCleaners')
  },
  methods: {
    searchEvents() {
      this.isFetching = true
      this.isEmpty = false
      let payload = {
        email: this.selectedCleaner,
        eventName: this.eventName
      }
      if (this.dateRange.length) {
        payload.startDate = this.dateRange[0]
        payload.endDate = this.dateRange[1]
      }
      this.$store.dispatch('cleanerEvents/fetchEvents', payload).then(
        () => {
          this.isFetching = false
          if (!this.items.length) {
            this.isEmpty = true
          }
        }
      )
    },
    exportReport () {
      let datas = this.items
      let keys = [
        'userName',
        'page',
        'eventName',
        'eventDetail',
        'createdAt'
      ]
      let headers = [
        'Username',
        'Page',
        'Event Name',
        'Event Detail',
        'Created At'
      ]

      // Change status inside datas from number to string
      datas = datas.map(obj => ({
        ...obj,
        eventDetail: obj.eventDetail ? JSON.stringify(obj.eventDetail) : '',
        createdAt: this.$options.filters.date(obj.createdAt)
      }))

      const FILENAME = `CLEANER_EVENTS_${this.selectedCleaner}`
      let wb = helperService.exportToExcel(datas, headers, keys)
      wb.writeToBuffer().then((buffer) => {
        let data = new Blob([buffer])
        FileSaver.saveAs(data, `${FILENAME}.xlsx`)
        toastr.info('File has been downloaded')
      })
    }
  }
}
</script>
